module.exports = "https://static.cdns.space/classicbook-temp-tx/img/1-1.8ae72f52.jpg";